// libraries
import React, { useContext, useState, useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { PieChart, Pie, Cell } from "recharts";
import { Modal } from "reactstrap";
// import { BsDownload } from "react-icons/bs";
import moment from "moment";
import { Player } from "video-react";
import "video-react/dist/video-react.css";
import TextareaAutosize from 'react-textarea-autosize';
//component
import AppButton from "components/app-button";
import pathnames from "routes/pathnames";
import { updateUserList } from "redux/slices/user-list-slice";
import AppOpenVidu from "components/app-open-vidu";
// api
// import api from "services/api";
import AppCustomToast, { PageContext } from "components/app-custom-toast";
// commons
import CONSTANSTS from "common/constansts";
// assests
import iconPlay from "assets/images/pages/icon-play-video.png";
import iconClose from "assets/images/pages/icons8-close-60.png";
import { IoEyeOutline, IoClose } from "react-icons/io5";
import IconDownload from "../../assets/images/pages/icon-download-border-none.png";
// import IconUpload from "../../assets/images/pages/icon-upload.png";
// import appToast from "components/app-toast";

const getTableRowClassNames = (index) => {
  const classNames = ["audit-trail-modal__table-row"];
  if (index % 2 === 0) classNames.push("audit-trail-modal__table-row--gray");

  return classNames.join(" ");
};

const AuditTrailModal = ({ isOpen, toggle, dataList }) => {
  return (
    <Modal className="audit-trail-modal" contentClassName="audit-trail-modal__content" isOpen={isOpen}>
      <div className="audit-trail-modal__body">
        <div className="audit-trail-modal__header-row">
          <div className="audit-trail-modal__column-timestamp">
            <span>Timestamp</span>
          </div>
          <div className="audit-trail-modal__column-details">Details</div>
          <div className="audit-trail-modal__column-by">By</div>
        </div>
        <div className="audit-trail-modal__table-body">
          {dataList && dataList.length
            ? dataList.map((o, i) => (
                <div key={i} className={getTableRowClassNames(i)}>
                  <div className="audit-trail-modal__column-timestamp">
                    <span>{o.timestamp}</span>
                  </div>
                  <div className="audit-trail-modal__column-details">{o.message}</div>
                  <div className="audit-trail-modal__column-by">{o.updatedBy}</div>
                </div>
              ))
            : null}
        </div>
      </div>
      <div className="audit-trail-modal__button-wrapper">
        <AppButton colorType="orange" label="Back" onClick={toggle} />
      </div>
    </Modal>
  );
};

const getTabClassNames = (tabStatus, type) => {
  const classNames = ["loan-application-view__score-button"];
  if (tabStatus === 2) classNames.push("loan-application-view__score-button--active");
  if (type === "ctos") classNames.push("loan-application-view__score-button--darker");
  return classNames.join(" ");
};

const getTabScoreClassNames = (tabStatus) => {
  const classNames = ["loan-application-view__score-point"];
  if (tabStatus === 2) classNames.push("loan-application-view__score-point--active");

  return classNames.join(" ");
};

const getTabTitleClassNames = (tabStatus) => {
  const classNames = ["loan-application-view__score-label-title"];
  if (tabStatus === 2) classNames.push("loan-application-view__score-label-title--active");
  return classNames.join(" ");
};

const getTabSubtitleClassNames = (tabStatus) => {
  const classNames = ["loan-application-view__score-label-subtitle"];
  if (tabStatus === 2) classNames.push("loan-application-view__score-label-subtitle--active");
  return classNames.join(" ");
};

const getVideoTabClassNames = (videoTab, currentTab) => {
  const classNames = ["loan-application-view__video-tab-button"];
  if (videoTab[currentTab] === 1) classNames.push("loan-application-view__video-tab-button--active");
  return classNames.join(" ");
};

const getVideoWrapperClassNames = (scoreTab) => {
  const classNames = ["loan-application-view__video-wrapper"];
  if (scoreTab.ctos === 0 && scoreTab.ivc === 0) classNames.push("loan-application-view__video-wrapper--show");
  return classNames.join(" ");
};

const getLiveVideoClassNames = (show) => {
  const classNames = ["loan-application-view__video-body--hide"];
  if (show) classNames.push("loan-application-view__video-body--show");
  return classNames.join(" ");
};

const PageLoanApplicationView = (from) => {
  console.log("Loan Application Detail - props: ", from.location.state)
  const indicatorValue = useContext(PageContext);
  function messageDialog(indicator) {
    AppCustomToast({
      showIndicator: indicator,
      reintIndicator: indicatorValue[1](indicator),
    });
  }
  const history = useHistory();
  const { staffId } = useParams();
  const dispatch = useDispatch();

  const inputField = {
    assign: {
      value: "",
    },
    applicantName: {
      error: false,
      value: "",
      placeholder: "Applicant Name",
      required: "Cannot be empty",
      invalid: "",
    },
    loanInterestRate: {
      error: false,
      value: "",
      placeholder: "Loan Interst Rate",
      required: "Cannot be empty",
      invalid: "",
    },
    requestDate: {
      error: false,
      value: "",
      placeholder: "",
      required: "Date required",
      invalid: "",
    },
    loanTenure: {
      error: false,
      value: "",
      placeholder: "Loan Tenure",
      required: "Loan Tenure required",
      invalid: "Invalid Role",
    },
    nric: {
      error: false,
      value: "",
      placeholder: "Enter NRIC",
      required: "Password required",
      invalid: "Invalid, please provide correct format",
    },
    mobile: {
      error: false,
      value: "",
      placeholder: "Mobile no.",
      required: "Mobile number required",
      invalid: "",
    },
    email: {
      error: false,
      value: "",
      placeholder: "Email",
      required: "Email required",
      invalid: "",
    },
    contactDetails: {
      error: false,
      value: "",
      placeholder: "Contact Details",
      required: "Contact Details required",
      invalid: "",
    },
    remarks: {
      error: false,
      value: "",
      placeholder: "Select Remarks",
      required: "Remarks required",
      invalid: "",
    },
    applicantEmail: {
      value: "",
    },
    loanAmount: {
      value: "",
    },
    username: {
      value: ""
    },
    unattendedRemark: {
      error: false,
      value: "",
    },
    monthlyIncome: {
      error: false,
      value: 0,
    },
  };

  const labelField = {
    applicantId: {
      value: "",
    },
    preRecordedVideo: {
      value: "",
    },
    liveBriefing: {
      value: "",
    },
    liveBriefingPreferredDate: {
      value: "",
    },
    liveBriefingScheduledDate: {
      value: "",
    },
    eAgreement: {
      value: "",
    },
    contractId: {
      value: "",
    },
  };
  const [input, setInput] = useState(inputField);
  const [label, setLabel] = useState(labelField);
  const [viewData, setViewData] = useState({});
  const [rejectReason, setRejectReason] = useState([]);
  const [scoreTab, setScoreTab] = useState({
    // 0 = hide
    // 1 = unselect
    // 2 = selected
    ctos: 0,
    ivc: 0,
  });
  const [videoTab, setVideoTab] = useState({
    // 0 = unselect
    // 1 = selected
    interview: 1,
    briefing: 0,
  });
  const [headerButton, setHeaderButton] = useState({
    middle: {
      label: "",
      disable: false,
    },
    right: {
      label: "Reject",
    },
  });
  const [auditTrailModal, setAuditTrailModal] = useState({
    isOpen: false,
  });

  const headerButtonFunction = (status) => {
    switch (status.toLowerCase()) {
      case "new":
        setHeaderButton({
          middle: {
            label: "Initial Approval",
            disable: false,
          },
          right: {
            label: "Reject",
          },
        });
        break;

      case "initial approved":
        setHeaderButton({
          middle: {
            label: "Initial Approval",
            disable: true,
          },
          right: {
            label: "Reject",
          },
        });
        break;

      case "in review":
        setHeaderButton({
          middle: {
            label: "Initial Approval",
            disable: false,
          },
          right: {
            label: "Reject",
          },
        });
        break;

      case "approved":
        setHeaderButton({
          middle: {
            label: "Final Approval",
            disable: true,
          },
          right: {
            label: "Reject",
          },
        });

        break;

      case "live briefing":
        setHeaderButton({
          middle: {
            label: "Sign Agreement",
            disable: true,
          },
          right: {
            label: "Reject",
          },
        });
        setVideoTab({
          briefing: 1,
          interview: 0,
        });

        break;

      case "sign agreement":
        setHeaderButton({
          middle: {
            label: "Sign Agreement",
            disable: true,
          },
          right: {
            label: "Reject",
          },
        });
        break;

      case "completed":
        setHeaderButton({
          middle: {
            label: "Complete",
            disable: false,
          },
          right: {
            label: "View Contract",
          },
        });
        break;

      case "rejected":
        setHeaderButton({
          middle: {
            label: "",
            disable: true,
          },
          right: {
            label: "Reject",
          },
        });
        break;

      default:
        break;
    }
  };
  const [contractId, setContractId] = useState({
    value: null,
  });

  const [loanDetailsAccess, setLoanDetailsAccess] = useState({
    approval: false,
    pre_approval: false,
    assign_officer: false,
    audit_trail: false,
    generate_agreement: false,
    interview: false,
    is_recording_existed: false,
    leave: false,
    live_briefing: false,
    update_remark: false,
    update_status: false,
    view_ctos_score: false,
    view_ivc_score: false,
    view_loan_detail: false,
    view_ivc_score_detail: false,
    view_ctos_score_detail: false,
    view_ctos_report: false,
    update_unattended_remark: false,
  })

  const [supportingDocs, setSupportingDocs] = useState([]);
  const [disableRejectButton, setDisableRejectButton] = useState(false);

  const [disableSaveBtn, setDisableSaveBtn] = useState(false);

  // const inputFile = useRef();

  // const [file, setFile] = useState();

  useEffect(() => {
    const appId = staffId;
    let loanAccess = null;
    loanAccess = JSON.parse(localStorage.getItem("accessMatrix"));
    if (loanAccess) {
      setLoanDetailsAccess(loanAccess.accessMatrix.Loan_Application_Detail);

      //change the default video tab when Live Briefing is not accessable and Interview is accessable
      if (!loanAccess.accessMatrix.Loan_Application_Detail.interview && loanAccess.accessMatrix.Loan_Application_Detail.live_briefing) {
        setVideoTab({
          interview: 0,
          briefing: 1,
        })
      }
    }
    const loadData = async () => {
      try {
        let token = null;
        token = localStorage.getItem("@storage_token");
        // let response = fetch("http://49.0.203.50/ivc-app/bo/loanAppplication/api/v1/get/" + appId, {
        let response = fetch(process.env.REACT_APP_API_URL + CONSTANSTS.ENDPOINT_PATH.GET_LOAN_BYID + appId, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "*/*",
            "Accept-language": "en", "X-DEVICE-OS": "Web",
            Authorization: "Bearer " + token,
          },
        })
          .then(function (response) {
            return response.json();
          })
          .then(function (data) {
            if (data.responseCode === 200) {
              if (data !== null || data !== undefined) {
                let result = data.result;
                setContractId(Object.getOwnPropertyDescriptor(result, "contractId"));
                // console.log("res", result.interviewUrl)
              //  console.log("nricFrontUrl", result.nricFrontUrl)
                setViewData(result);

                // 2023-02-23: move documents out from internalScoreBreakdown object
                setSupportingDocs(result.documents);

                setDisableRejectButton(result.status.toLowerCase() === "rejected" 
                                      || result.status.toLowerCase() === "approved");
               
                headerButtonFunction(result.status);  
                
                setRejectReason(Object.entries(result.rejectedReasonList));
                if (result.status.toLowerCase() === "kyc interview") {
                  // console.log("1", result.interviewDate);
                  if (result.interviewDate !== null && result.rejectedReason === null) {
                    // console.log("2");
                    setHeaderButton({
                      middle: {
                        label: "Recommend Approval",
                        disable: false,
                      },
                      right: {
                        label: "Reject",
                      },
                    });
                  }
                } else if (result.status.toLowerCase() === "live briefing") {
                  if (result.liveBriefingDate !== null && result.rejectedReason === null) {
                    setHeaderButton({
                      middle: {
                        label: "Sign Agreement",
                        disable: false,
                      },
                      right: {
                        label: "Reject",
                      },
                    });
                  }
                } else if (result.status.toLowerCase() === "pre approved") {
                  setHeaderButton({
                    middle: {
                      label: "Final Approval",
                      disable: !loanAccess.accessMatrix.Loan_Application_Detail.approval,
                    },
                    right: {
                      label: "Reject",
                    },
                  });
                }
                setInput({
                  ...input,
                  applicantName: {
                    error: false,
                    value: result.applicantName,
                  },
                  loanInterestRate: {
                    value: result.interestRate,
                  },
                  // requestDate: {
                  //   value: result.interviewDate,
                  // },
                  requestDate: {
                    value: result.requestDate,
                  },
                  loanTenure: {
                    value: result.loanTenure,
                  },
                  nric: {
                    value: result.applicantNric,
                  },
                  email: {
                    value: result.applicantEmail,
                  },
                  mobile: {
                    value: result.applicantMobile,
                  },
                  applicantEmail: {
                    value: result.applicantEmail,
                  },
                  remarks: {
                    value: result.remark,
                  },
                  loanAmount: {
                    value: result.loanAmount
                  },
                  username: {
                    value: result.username
                  },
                  unattendedRemark: {
                    value: result.unattendedRemark
                  },
                  monthlyIncome: {
                    value: result.monthlyIncome
                  }
                });
                setLabel({
                  ...label,
                  applicantId: {
                    value: result.loanApplicationReferenceNumber,
                  },
                  preRecordedVideo: {
                    value: result.preRecordedVideoDate,
                  },
                  liveBriefing: {
                    value: result.liveBriefingDate,
                  },
                  liveBriefingPreferredDate: {
                    value: result.liveBriefingScheduledDate,
                  },
                  liveBriefingScheduledDate: {
                    value: result.liveBriefingScheduledDate,
                  },
                  eAgreement: {
                    value: result.loanAgreementDate,
                  },
                  contractId: {
                    value: result.loanContractReferenceNumber,
                  },
                });
              }
            } else {
              messageDialog({
                isOpen: true,
                condition: CONSTANSTS.DIALOG.failed,
                title: CONSTANSTS.DIALOG_TITLE.general_failed,
                message: data.message,
                defaultOnClick: false,
                onClick: () => history.push(pathnames.pageLoanApplicationList),
              });
            }
          });
        dispatch(updateUserList(response));
      } catch (error) {
        console.log(error);
      }
    };
    loadData();
  }, []);

  const [signAgreementOnClick, setSignAgreementOnClick] = useState(false);

  const statusUpdate = () => {
    let status = "";
    if (headerButton.middle.label.toLowerCase().replace(/\s/g, "") === "complete") {
      history.push(pathnames.pageLoanApplicationList);
    }
    if (headerButton.middle.label.toLowerCase().replace(/\s/g, "") === "initialapproval") {
      status = "INITIAL_APPROVED";
    }
    // if (headerButton.middle.label.toLowerCase().replace(/\s/g, "") === "initialapproval") {
    //   status = "APPROVED";
    // }
    if (headerButton.middle.label.toLowerCase().replace(/\s/g, "") === "recommendapproval") {
      status = "PRE_APPROVED";
    }
    if (headerButton.middle.label.toLowerCase().replace(/\s/g, "") === "finalapproval") {
      status = "APPROVED";
    }
    if (headerButton.middle.label.toLowerCase().replace(/\s/g, "") === "signagreement") {
      // status = "SIGNAGREEMENT";
      if (signAgreementOnClick === false) {
        generateLoanAgreement();
      }
    }
    let payload = {
      referenceNumber: viewData.loanApplicationReferenceNumber,
      rejectedReason: "",
      status: status,
    };
    if (status) {
      // fetch("http://49.0.203.50/ivc-app/bo/loanAppplication/api/v1/updateStatus", {
      fetch(process.env.REACT_APP_API_URL + CONSTANSTS.ENDPOINT_PATH.UPDATE_LOAN_STATUS, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
          "Accept-language": "en", "X-DEVICE-OS": "Web",
          Authorization: "Bearer " + localStorage.getItem("@storage_token"),
        },
        body: JSON.stringify(payload),
      })
        .then((response) => response.json())
        .then((json) => {
          if (json.responseCode === 200) {
            messageDialog({ isOpen: true, condition: CONSTANSTS.DIALOG.success, title: CONSTANSTS.DIALOG_TITLE.general_success, message: json.message });
            // appToast("Successfully update status", true);

            // to redirect back to loan application list with status filtering after approve or reject
            if (from.location.state.status) {
              history.push(pathnames.pageLoanApplicationList, {status: from.location.state.status})
            }
          } else {
            messageDialog({ isOpen: true, condition: CONSTANSTS.DIALOG.failed, title: CONSTANSTS.DIALOG_TITLE.general_failed, message: json.message, defaultOnClick: false });
          }
        });
    }
  };

  const rejectReasonUpdate = (rr) => {
    let payload = {
      referenceNumber: viewData.loanApplicationReferenceNumber,
      rejectedReason: rr,
      status: "REJECTED",
    };

    if (rr) {
      // fetch("http://49.0.203.50/ivc-app/bo/loanAppplication/api/v1/updateStatus", {
      fetch(process.env.REACT_APP_API_URL + CONSTANSTS.ENDPOINT_PATH.UPDATE_LOAN_STATUS, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
          "Accept-language": "en", "X-DEVICE-OS": "Web",
          Authorization: "Bearer " + localStorage.getItem("@storage_token"),
        },
        body: JSON.stringify(payload),
      })
        .then((response) => response.json())
        .then((json) => {
          if (json.responseCode === 200) {
            // appToast("Successfully update reject status", true);
            
            // to redirect back to loan application list with status filtering after approve or reject
            if (from.location.state.status) {
              history.push(pathnames.pageLoanApplicationList, {status: from.location.state.status})
            }
            // history.go(0);
          } else {
            messageDialog({ isOpen: true, condition: CONSTANSTS.DIALOG.failed, title: CONSTANSTS.DIALOG_TITLE.general_failed, message: json.message, defaultOnClick: false });
          }
        });
    }
  };

  const auditTrail = () => {
    setAuditTrailModal({ isOpen: true });
  };

  const [style, setStyle] = useState("dropdown-content");
  const [buttonStyle, setButtonStyle] = useState("dropButton");
  const changeStyle = () => {
    if (style === "dropdown-content") {
      setStyle("dropdown-content show");
    } else {
      setStyle("dropdown-content");
    }
    if (buttonStyle === "dropButton") {
      setButtonStyle("dropButtonHover");
    } else {
      setButtonStyle("dropButton");
    }
  };

  const staffAssignedFunction = (staffUsername) => {
    // let response = fetch("http://49.0.203.50/ivc-app/bo/loanAppplication/api/v1/assign", {
    let response = fetch(process.env.REACT_APP_API_URL + CONSTANSTS.ENDPOINT_PATH.ASSIGN_AGENT, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "*/*",
        "Accept-language": "en", "X-DEVICE-OS": "Web",
        Authorization: "Bearer " + localStorage.getItem("@storage_token"),
      },
      body: JSON.stringify({
        referenceNumber: viewData.loanApplicationReferenceNumber,
        username: staffUsername,
      }),
    })
      .then((response) => response.json())
      .then((json) => {
        if (json.responseCode === 200) {
          // appToast("Successfully update assigned staff", true);
          history.go(0);
        } else {
          messageDialog({ isOpen: true, condition: CONSTANSTS.DIALOG.failed, title: CONSTANSTS.DIALOG_TITLE.general_failed, message: json.message, defaultOnClick: false });
        }
      });
    dispatch(updateUserList(response));
  };

  const updateRemark = () => {
    let token = null;
    token = localStorage.getItem("@storage_token");
    try {
      // let response = fetch("http://49.0.203.50/ivc-app/bo/loanAppplication/api/v1/updateRemark", {
      let response = fetch(process.env.REACT_APP_API_URL + CONSTANSTS.ENDPOINT_PATH.UPDATE_LOAN_REMARK, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
          "Accept-language": "en", "X-DEVICE-OS": "Web",
          Authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          referenceNumber: viewData.loanApplicationReferenceNumber,
          remark: input.remarks.value,
        }),
      })
        .then((response) => response.json())
        .then((json) => {
          if (json.responseCode === 200) {
            messageDialog({ isOpen: true, condition: CONSTANSTS.DIALOG.success, title: CONSTANSTS.DIALOG_TITLE.general_success, message: json.message });

            // appToast("Remark successfully update", true);
          } else {
            messageDialog({ isOpen: true, condition: CONSTANSTS.DIALOG.failed, title: CONSTANSTS.DIALOG_TITLE.general_failed, message: json.message, defaultOnClick: false });
            // appToast(json.message, false);
          }
        });
      dispatch(updateUserList(response));
    } catch (error) {
      console.log("error", error);
    }
  };

  const updateUnattendedRemark = () => {
    let token = null;
    token = localStorage.getItem("@storage_token");
    try {
      // let response = fetch("http://49.0.203.50/ivc-app/bo/loanAppplication/api/v1/updateUnatttendedRemark", {
      let response = fetch(process.env.REACT_APP_API_URL + CONSTANSTS.ENDPOINT_PATH.UPDATE_LOAN_UNATTENDED_REMARK, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
          "Accept-language": "en", "X-DEVICE-OS": "Web",
          Authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          referenceNumber: viewData.loanApplicationReferenceNumber,
          unattendedRemark: input.unattendedRemark.value,
        }),
      })
        .then((response) => response.json())
        .then((json) => {
          if (json.responseCode === 200) {
            messageDialog({ isOpen: true, condition: CONSTANSTS.DIALOG.success, title: CONSTANSTS.DIALOG_TITLE.general_success, message: json.message });

            // appToast("Remark successfully update", true);
          } else {
            messageDialog({ isOpen: true, condition: CONSTANSTS.DIALOG.failed, title: CONSTANSTS.DIALOG_TITLE.general_failed, message: json.message, defaultOnClick: false });
            // appToast(json.message, false);
          }
        });
      dispatch(updateUserList(response));
    } catch (error) {
      console.log("error", error);
    }
  };

  const onHandleOnChange = (event) => {
    const name = event.currentTarget.name;
    const value = event.currentTarget.value;

    setInput({
      ...input,
      [name]: {
        ...input[name],
        value: value,
      },
    });
  };

  const scoreTabClicked = (name) => {
    if (scoreTab[name] === 0 || scoreTab[name] === 1) {
      if (scoreTab.ctos === 2) {
        setScoreTab({
          ctos: 1,
          ivc: 2,
        });
      } else if (scoreTab.ivc === 2) {
        setScoreTab({
          ctos: 2,
          ivc: 1,
        });
      } else {
        setScoreTab({
          ...scoreTab,
          [name]: 2,
        });
      }
    } else if (scoreTab[name] === 2) {
      setScoreTab({
        ctos: 0,
        ivc: 0,
      });
    }
  };

  const pieDataCtos = [
    {
      name: "remaining",
      value: 100 - viewData.ctosCreditScore,
    },
    {
      name: "score",
      value: viewData.ctosCreditScore,
    },
  ];

  const pieDataIvc = [
    {
      name: "remaining",
      value: 100 - viewData.internalScore,
    },
    {
      name: "score",
      value: viewData.internalScore,
    },
  ];

  const pieColors = {
    remaining: "#ffffff",
    score: "#f5903d",
  };

  const videoTabHandler = (type) => {
    if (type === "interview") {
      setVideoTab({
        interview: 1,
        briefing: 0,
      });
    } else if (type === "briefing") {
      setVideoTab({
        interview: 0,
        briefing: 1,
      });
    } else {
      setVideoTab({
        interview: 0,
        briefing: 0,
      });
    }
  };

  const downloadIvcDocs = (documentUrl, code, label) => {
    fetch(documentUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "*/*",
        "Accept-language": "en", "X-DEVICE-OS": "Web",
        Authorization: "Bearer " + localStorage.getItem("@storage_token"),
      },
    })
      .then((response) => response.blob())
      .then((responseBlob) => {
        const link = document.createElement("a");
        link.target = "_blank";
        link.download = `${code}_${label}`;
        link.href = URL.createObjectURL(new Blob([responseBlob], { type: responseBlob.type }));
        link.click();
      });
  };

  const openCtosReportHtml = () => {
    if (!viewData.ctosScorecardUuid) {
      messageDialog({ isOpen: true, condition: CONSTANSTS.DIALOG.failed, title: CONSTANSTS.DIALOG_TITLE.general_failed, message: "CTOS report is not available." });
      return;
    }
    fetch(process.env.REACT_APP_API_URL + CONSTANSTS.ENDPOINT_PATH.COMMON_CTOS_REPORT + viewData.ctosScorecardUuid, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "*/*",
        "Accept-language": "en", "X-DEVICE-OS": "Web",
        Authorization: "Bearer " + localStorage.getItem("@storage_token"),
      },
    })
      .then((response) => {
        if (!response.ok) {
          return response.text().then((text) => {
            throw new Error(text || "Failed to load CTOS report.");
          });
        }
        return response.text();
      })
      .then((html) => {
        const popup = window.open("", "_blank", "width=1000,height=800");
        if (popup) {
          popup.document.open();
          popup.document.write(html);
          popup.document.close();
        } else {
          messageDialog({ isOpen: true, condition: CONSTANSTS.DIALOG.failed, title: CONSTANSTS.DIALOG_TITLE.general_failed, message: "Please allow pop-ups to view the CTOS report." });
        }
      })
      .catch((err) => {
        console.log("openCtosReportHtml - error", err);
        messageDialog({ isOpen: true, condition: CONSTANSTS.DIALOG.failed, title: CONSTANSTS.DIALOG_TITLE.general_failed, message: "Failed to load CTOS report." });
      });
  };

  const headerThirdButton = (label) => {
    if (label === "View Contract") {
      // let contractNumber = viewData.loanContractReferenceNumber.substring(7).replace(/^[0]+/g, "");
      history.push(pathnames.pageLoanContractView.replace(":contractId", contractId.value));
    } else if (label === "Sign Agreement") {
      // generateLoanAgreement();
    } else {
      changeStyle();
    }
  };

  const generateLoanAgreement = () => {
    setSignAgreementOnClick(true);
    let token = null;
    token = localStorage.getItem("@storage_token");
    // fetch("http://49.0.203.50/ivc-app/bo/loanAppplication/api/v1/generateLoanAgreement/" + viewData.loanApplicationReferenceNumber, {
    fetch(process.env.REACT_APP_API_URL + CONSTANSTS.ENDPOINT_PATH.GENERATE_LOAN_AGREEMENT + viewData.loanApplicationReferenceNumber, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "*/*",
        "Accept-language": "en", "X-DEVICE-OS": "Web",
        Authorization: "Bearer " + token,
      },
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        if (data.responseCode === 200) {
          // console.log(items)
          messageDialog({ isOpen: true, condition: CONSTANSTS.DIALOG.success, title: CONSTANSTS.DIALOG_TITLE.general_success, message: data.message });

          history.go(0);
        } else {
          setSignAgreementOnClick(false);
          messageDialog({ isOpen: true, condition: CONSTANSTS.DIALOG.failed, title: CONSTANSTS.DIALOG_TITLE.general_failed, message: data.message, defaultOnClick: false });
        }
      });
  };

  const [interviewVideo, setInterviewVideo] = useState(false);
  const selectInterviewVideo = (e) => {
    setInterviewVideo(e);
  }
  const [liveBriefingVideo, setLiveBriefingVideo] = useState(false);
  const selectLiveBriefingVideo = (e) => {
    setLiveBriefingVideo(e);
  }

  const [nricImage, setnricImage] = useState(false);

  function PopUpNRIC(props) {
    return props.trigger ? (
      <div className="pop-up">
      <div className="pop-up-data">
        {props.children}
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <button className="pop-up-button" style={{ margin: "15px 0px 15px 0px" }} onClick={() => setnricImage(false)}>
            Back
          </button>
        </div>
      </div>
    </div>
    ) : 
    (<div></div>)
  }

  const renderUnauthorizedMsg = () => {
    return (
      <div style={{display: "flex", justifyContent: "center", alignSelf: "center", paddingTop: "180px"}}>
        <div style={{height: "100%", fontFamily: "gotham-bold", fontSize: "22px"}}>Sorry, but you do not have the authority to view this section.</div>
      </div>
    )
  }

  const renderNoRecordMsg = () => {
    return (
      <div style={{display: "flex", justifyContent: "center", alignSelf: "center", paddingTop: "180px"}}>
        <div style={{height: "100%", fontFamily: "gotham-bold", fontSize: "22px"}}>No Record Due to The Applicant Failed to Meet the Loan Facilities Criteria</div>
      </div>
    )
  }

  const rejectSupportingDoc = (documentName) => {
    let status = "REJECTED";
    let token = null;
    token = localStorage.getItem("@storage_token");
    try {
      // let response = fetch("http://49.0.203.50/ivc-app//bo/loanAppplication/api/v1/updateLoanApplicationDocument/{loanApplicationReferenceNumber}", {
      let response = fetch(process.env.REACT_APP_API_URL + CONSTANSTS.ENDPOINT_PATH.REJECT_SUPPORTING_DOCUMENT + viewData.loanApplicationReferenceNumber + `?status=${status}&type=${documentName}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
          "Accept-language": "en", "X-DEVICE-OS": "Web",
          Authorization: "Bearer " + token,
        },
      })
        .then((response) => response.json())
        .then((json) => {
          if (json.responseCode === 200) {
            messageDialog({ isOpen: true, condition: CONSTANSTS.DIALOG.success, title: CONSTANSTS.DIALOG_TITLE.general_success, message: json.message });

            // appToast("Remark successfully update", true);
          } else {
            messageDialog({ isOpen: true, condition: CONSTANSTS.DIALOG.failed, title: CONSTANSTS.DIALOG_TITLE.general_failed, message: json.message, defaultOnClick: false });
            // appToast(json.message, false);
          }
        });
      dispatch(updateUserList(response));
    } catch (error) {
      console.log("error", error);
    }
  }

  // const uploadSupportingDocument = (documentName, fileObj) => {
  //   const formData = new FormData();
  //   console.log("#@#", fileObj)
  //   formData.append("document", fileObj);

  //   let token = null;
  //   token = localStorage.getItem("@storage_token");
  //   try {
  //     // let response = fetch("http://49.0.203.50/ivc-app//bo/loanAppplication/api/v1/uploadLoanApplicationDocument/{loanApplicationReferenceNumber}", {
  //     let response = fetch(process.env.REACT_APP_API_URL + CONSTANSTS.ENDPOINT_PATH.UPLOAD_SUPPORTING_DOCUMENT + viewData.loanApplicationReferenceNumber + `?type=${documentName}`, {
  //       method: "POST",
  //       headers: {
  //         // "Content-Type": "application/json",
  //         Accept: "*/*",
  //         "Accept-language": "en", "X-DEVICE-OS": "Web",
  //         Authorization: "Bearer " + token,
  //       },
  //       body: formData,
  //     })
  //       .then((response) => response.json())
  //       .then((json) => {
  //         if (json.responseCode === 200) {
  //           messageDialog({ isOpen: true, condition: CONSTANSTS.DIALOG.success, title: CONSTANSTS.DIALOG_TITLE.general_success, message: json.message });

  //           // appToast("Remark successfully update", true);
  //         } else {
  //           messageDialog({ isOpen: true, condition: CONSTANSTS.DIALOG.failed, title: CONSTANSTS.DIALOG_TITLE.general_failed, message: json.message, defaultOnClick: false });
  //           // appToast(json.message, false);
  //         }
  //       });
  //     dispatch(updateUserList(response));
  //   } catch (error) {
  //     console.log("error", error);
  //   }
  // }

  // const handleFileChange = (event, documentName) => {
  //   let inputFile = event.target.files[0];
  //   console.log("->", inputFile);

  //   // check file size
  //   // https://stackoverflow.com/questions/33531140/get-file-size-in-mb-or-kb?msclkid=389800bbb70111ec8058dc0ac41435f5
  //   var _size = inputFile.size;
  //   var fSExt = new Array("Bytes", "KB", "MB", "GB"),
  //     i = 0;
  //   while (_size > 900) {
  //     _size /= 1024;
  //     i++;
  //   }
  //   var num = Math.round(_size * 100) / 100;
  //   var exactSize = num + " " + fSExt[i];
  //   console.log("FILE SIZE = ", exactSize);

  //   if (i > 2) {
  //     // GB
  //     appToast("Uploaded file or image cannot exceed 5 MB", false);
  //   } else if (i === 2 && num > 5) {
  //     // exceed 500 MB
  //     appToast("Uploaded file or image cannot exceed 5 MB", false);
  //   } else {
  //     uploadSupportingDocument(documentName, inputFile);
  //   }
  // };

  // const openFile = () => {
  //   inputFile.current.click();
  // };

  return (
    <div className="application-view">
      <AuditTrailModal dataList={viewData.auditTrails ? viewData.auditTrails : []} isOpen={auditTrailModal.isOpen} toggle={() => setAuditTrailModal({ isOpen: false })} />
      <div className="top-context" style={{ padding: "0px 50px 30px 50px" }}>
        <div className="title">Loan Application</div>
        {(loanDetailsAccess.approval || loanDetailsAccess.pre_approval) && 
        <>
        <div className="search-button">
          {disableRejectButton && 
            <AppButton colorType="orange" 
              disableTransparent={disableRejectButton} 
              disabled={disableRejectButton} 
              label={headerButton.right.label} 
              onClick={() => headerThirdButton(headerButton.right.label)}
            ></AppButton>
          }
          <div className="dropdown">
            {!disableRejectButton &&
              <button className={"dropSpan " + buttonStyle} onClick={() => headerThirdButton(headerButton.right.label)}>
                {headerButton.right.label}
              </button>
            }
            <div className={style} style={{ width: "350px", color: "#9D9D9C" }}>
              <ul className="dropdown-reject" onClick={() => changeStyle()}>
                <li>Reject</li>
              </ul>
              <div className="dropdown-divider-wrapper">
                <div className="dropdown-divider" />
              </div>
              {rejectReason.length &&
                rejectReason.map((a, i) => {
                  return (
                    <ul
                      key={i}
                      className="dropdown-selection"
                      onClick={() => {
                        rejectReasonUpdate(a[0]);
                        changeStyle();
                      }}
                    >
                      <li>{a[1]}</li>
                    </ul>
                  );
                })}
            </div>
          </div>
        </div>

        {viewData.status === "Rejected" || viewData.status === "Pending" ? null : (
          <div className="search-button">
            <AppButton colorType="orange" disableTransparent={headerButton.middle.disable} disabled={headerButton.middle.disable} label={headerButton.middle.label} onClick={statusUpdate}></AppButton>
          </div>
        )}
        </>
        }
        <div className="search-button" hidden={!loanDetailsAccess.audit_trail}>
          <AppButton colorType="orange" label="Audit Trail" onClick={auditTrail}></AppButton>
        </div>
      </div>

      <div className="application-detail">
        <div className="wrapper">
          <div className="review">
            <div>
              <span className="assigned">Assigned</span>
              <span className="reviewing">
                {viewData.status}
                {viewData.rejectedReason ? ` - ${viewData.rejectedReason}` : ""}
              </span>
            </div>
            <div>
              {viewData.officerList && Object.entries(viewData.officerList).length ? (
                <select className="select-field" 
                  value={viewData.officerUsername ? viewData.officerUsername : "none"} 
                  onChange={(e) => staffAssignedFunction(e.target.value)} 
                  disabled={!loanDetailsAccess.assign_officer}
                  style={!loanDetailsAccess.assign_officer ? {cursor: 'not-allowed'} : {}}
                >
                  {Object.entries(viewData.officerList).map((a, i) => {
                    return (
                      <option key={i} value={a[0]}>
                        {a[1]}
                      </option>
                    );
                  })}
                  <option disabled>none</option>
                </select>
              ) : null}
              <span className="largeText">{viewData !== undefined ? viewData.loanApplicationReferenceNumber : ""}</span>
            </div>
            <hr />
            <div>
              <div className="content">
                <div>
                  <span>Applicant Name</span>
                  <input type="text" value={input.applicantName.value ? input.applicantName.value : ""} readOnly />
                </div>
                <div>
                  <span>Loan Amount</span>
                  <input type="text" value={input.loanAmount.value ? "RM " + input.loanAmount.value.toLocaleString() : ""} readOnly/>
                </div>
              </div>
              <div className="content">
                <div>
                  <span>Request Date</span>
                  <input type="text" value={input.requestDate.value ? input.requestDate.value : ""} readOnly />
                </div>
                <div>
                  <span>Loan Interest Rate</span>
                  <input type="text" value={input.loanInterestRate.value ? parseFloat(input.loanInterestRate.value).toFixed(2) + "%" : ""} readOnly />
                </div>
              </div>
              <div className="content">
                <div>
                  <span>NRIC</span>
                  <input type="text" value={input.nric.value ? input.nric.value : ""} readOnly/>
                  {/* {viewData.nricFrontUrl !== null ? */}
                  <a style={{position:"absolute", left:"480px", marginTop:"4px"}} onClick={() => setnricImage(true)}><IoEyeOutline size={24} /></a>
                  {/* :
                  ""} */}
                </div>
                <div>
                  <span>Loan Tenure</span>
                  <input type="text" value={input.loanTenure.value ? input.loanTenure.value + " years": ""} readOnly />
                </div>
              </div>
              <div className="content">
                <div>
                  <span>User Id</span>
                  <input type="text" value={input.username.value ? input.username.value : ""} readOnly />
                </div>
                <div>
                  <span>Email</span>
                  <input type="text" value={input.email.value ? input.email.value : ""} readOnly />
                </div>
              </div>
              <div className="content">
                <div>
                  <span>Mobile Phone</span>
                  <input type="text" value={input.mobile.value ? input.mobile.value : ""} readOnly />
                </div>
                <div>
                  <span>Monthly Income</span>
                  <input type="text" value={input.monthlyIncome.value ? "RM " + input.monthlyIncome.value.toLocaleString() : "N/A"} readOnly />
                </div>
              </div>
            </div>
            <PopUpNRIC trigger={nricImage}>
              <>
                <div>
                {viewData.nricFrontUrl !== null ?
                  <img src={viewData.nricFrontUrl} alt="nricFrontImageUrl" style={{maxWidth:"650px", paddingBottom: '15px'}}/>
                  : <p style={{padding:"10px"}}>There is no NRIC Front image to be display.</p>}
                </div>
                <div>{viewData.nricBackUrl !== null ?
                  <img src={viewData.nricBackUrl} alt="nricBackImageUrl" style={{maxWidth:"650px"}}/>
                  : <p style={{padding:"10px"}}>There is no NRIC Back image to be display.</p>}</div>
              </>
            </PopUpNRIC>

            {supportingDocs.length !== 0 ?
            // supportingDocs.length !== 0 && supportingDocs[0].documents != null ?
              <div className="supporting-doc">
                {supportingDocs.map((value, index) => {
                // supportingDocs[0].documents.length % 2 == 0 ?
                // supportingDocs[0].documents.map((value, index) => {
                    return(
                      <div key={value.documentName+index} className="supporting-doc-row">
                        <div className="supporting-doc-row-label" style={{textTransform: 'capitalize'}}>{value.documentName.replaceAll('_', ' ').toLowerCase()}</div>
                        {/* if it is rejected, show upload icon */}
                        {value.documentStatus == "ACCEPTED" ?
                          <div className="app-input" style={{ backgroundColor: "#FFFFFF", marginRight: '10px', marginLeft: '7px' }}>
                            <img src={IconDownload} alt="Download Icon" style={{ width: "30px", cursor: "pointer" }} onClick={() => downloadIvcDocs(value.documentUrl, viewData.loanApplicationReferenceNumber, value.documentName)} />
                            {viewData.status.toLowerCase() == "kyc interview" &&
                              <a style={{ marginTop:"2px", cursor: "pointer" }} onClick={() => rejectSupportingDoc(value.documentName)}><IoClose size={24} /></a>
                            }
                          </div>
                        :
                          <div className="app-input" style={{ backgroundColor: "#FFFFFF", marginRight: '10px', marginLeft: '7px' }}>
                            {/* <input type="file" name="file-input" id="file-input" ref={inputFile} accept="application/pdf, image/png, image/jpg, image/jpeg" style={{display: 'none'}} onChange={(event) => handleFileChange(event, value.documentName)} /> */}
                            {/* <img src={IconUpload} alt="upload icon" style={{ width: "30px", cursor: "pointer" }} /> */}
                            Rejected
                          </div>
                        }
                      </div>
                    )
                  })}
                {// empty but need to make it even in grid
                  supportingDocs.length % 2 !== 0 &&
                  <div className="supporting-doc-row">
                    <div className="supporting-doc-row-label"></div>
                    <div className="app-input" style={{ backgroundColor: "#FFFFFF", marginRight: '10px', marginLeft: '7px' }}>
                    </div>
                  </div>
                }
              </div>
              :
              <div className="supporting-doc">
                <div className="supporting-doc-row">
                  <div className="supporting-doc-row-label">Supporting Document</div>
                  <div className="app-input" style={{ backgroundColor: "#FFFFFF", marginRight: '10px' }}></div>
                </div>
                <div className="supporting-doc-row">
                  <div className="supporting-doc-row-label"></div>
                </div>
              </div>
            }

            <div className="interview-time">
              <div className="interview-time-row">
                <div className="interview-time-row-label">KYC Interview</div>
                <div>{viewData && viewData.interviewDate ? moment(viewData.interviewDate, "DD/MM/YYYY hh:mm A").format("DD/MM/YYYY HH:mm A") : "dd/mm/yyyy hh:mm"}</div>
              </div>
              <div className="interview-time-row">
                <div className="interview-time-row-label">Customer Preferred Date</div>
                <div>{viewData && viewData.interviewScheduledDate ? moment(viewData.interviewScheduledDate, "DD/MM/YYYY hh:mm A").format("DD/MM/YYYY HH:mm A") : "dd/mm/yyyy hh:mm"}</div>
              </div>
            </div>

            <div>
              <div className="bottom-content">
                <div>
                  <span>Pre-recorded video</span>
                  <input type="text" disabled value={label.preRecordedVideo.value ? label.preRecordedVideo.value : ""} />
                </div>
              </div>
              <div className="briefing-time-content">
                <div>
                  <div className="briefing-time-label">Live Briefing</div>
                  <div>{label.liveBriefing && label.liveBriefing.value ? moment(label.liveBriefing.value, "DD/MM/YYYY hh:mm A").format("DD/MM/YYYY HH:mm A") : "dd/mm/yyyy hh:mm"}</div>
                </div>
                <div>
                  <div className="briefing-time-label">Customer Preferred Date</div>
                  <div>
                    {label.liveBriefingPreferredDate && label.liveBriefingPreferredDate.value
                      ? moment(label.liveBriefingPreferredDate.value, "DD/MM/YYYY hh:mm A").format("DD/MM/YYYY HH:mm A")
                      : "dd/mm/yyyy hh:mm"}
                  </div>
                </div>
              </div>
              <div className="bottom-content">
                <div>
                  <span>e-Agreement</span>
                  <input type="text" disabled value={label.eAgreement.value ? label.eAgreement.value : ""} />
                </div>
              </div>
              <div className="bottom-content">
                <div>
                  <span>Contract ID</span>
                  <input type="text" disabled value={label.contractId.value ? label.contractId.value : ""} />
                </div>
              </div>
              <div className="bottom-content">
                <div>
                  <span>Remark</span>
                  <div className="remark">
                    <TextareaAutosize name="remarks" id="remarks" minRows={1} maxRows={6} onChange={onHandleOnChange} value={input.remarks.value ? input.remarks.value : ""} disabled={!loanDetailsAccess.update_remark} />
                    <button onClick={updateRemark} hidden={!loanDetailsAccess.update_remark || disableSaveBtn} disabled={disableSaveBtn}>Save</button>
                  </div>
                </div>
              </div>
              
            </div>
            <div className="bottom-content">
                <div>
                  <span>Unattended note: </span>
                  <div className="remark">
                    <TextareaAutosize name="unattendedRemark" id="unattendedRemark" minRows={1} maxRows={6} onChange={onHandleOnChange} value={input.unattendedRemark.value ? input.unattendedRemark.value : ""} disabled={!loanDetailsAccess.update_unattended_remark} />
                    <button onClick={updateUnattendedRemark} hidden={!loanDetailsAccess.update_unattended_remark || disableSaveBtn} disabled={disableSaveBtn}>Save</button>
                  </div>
                </div>
            </div>
            {loanDetailsAccess.view_ctos_report &&
                <div className="bottom-content">
                  <a href={viewData.ctosScorecardUrl} target="_blank" rel="noreferrer" className="loan-application-view__score-ctos-report">
                    View CTOS Report
                  </a>
                </div>
            }
            {loanDetailsAccess.view_ctos_report &&
                <div className="bottom-content">
                  <button
                    className="loan-application-view__score-ctos-report"
                    onClick={openCtosReportHtml}
                    style={{ border: "none", background: "none", cursor: "pointer", padding: 0, textAlign: "left" }}
                  >
                    View CTOS Report (HTML)
                  </button>
                </div>
            }
          </div>

          <div className="loan-application-view__score-wrapper">
            <div className="loan-application-view__score-button-row">
              {loanDetailsAccess.view_ctos_score &&
                <div className={getTabClassNames(scoreTab.ctos, "ctos")} onClick={() => scoreTabClicked("ctos")}>
                  <div className="loan-application-view__score-label-column">
                    <span className={getTabTitleClassNames(scoreTab.ctos)}>CTOS Score</span>
                    <span className={getTabSubtitleClassNames(scoreTab.ctos)}>CTOS info from API</span>
                  </div>
                  <div className="loan-application-view__score-graph-wrapper">
                    <span className="loan-application-view__score-graph">
                      <div className={getTabScoreClassNames(scoreTab.ctos)}>{viewData.ctosCreditScore}</div>
                      <PieChart width={70} height={70}>
                        <Pie line data={pieDataCtos} dataKey="value" nameKey="name" innerRadius={28} outerRadius={35} paddingAngle={1} strokeWidth={0}>
                          {pieDataCtos.map((entry, index) => {
                            return <Cell key={`cell-${index}`} fill={pieColors[entry.name]} />;
                          })}
                        </Pie>
                      </PieChart>
                    </span>
                  </div>
                </div>
              }
              {loanDetailsAccess.view_ivc_score && 
                <div className={getTabClassNames(scoreTab.ivc)} onClick={() => scoreTabClicked("ivc")}>
                  <div className="loan-application-view__score-label-column">
                    <span className={getTabTitleClassNames(scoreTab.ivc)}>IVC Score</span>
                    <span className={getTabSubtitleClassNames(scoreTab.ivc)}>IVC info (internal)</span>
                  </div>
                  <div className="loan-application-view__score-graph-wrapper">
                    <div className="loan-application-view__score-graph">
                      <div className={getTabScoreClassNames(scoreTab.ivc)}>{viewData.internalScore}</div>
                      <PieChart width={80} height={80}>
                        <Pie data={pieDataIvc} dataKey="value" nameKey="name" innerRadius={28} outerRadius={35} paddingAngle={1} strokeWidth={0}>
                          {pieDataIvc.map((entry, index) => {
                            return <Cell key={`cell-${index}`} fill={pieColors[entry.name]} />;
                          })}
                        </Pie>
                      </PieChart>
                    </div>
                  </div>
                </div>
              }
            </div>
            <div className="loan-application-view__score-content">
              {scoreTab.ctos === 2 && (
                <div className="loan-application-view__score-content-wrapper">
                {loanDetailsAccess.view_ctos_score_detail ? (
                  <>
                    {/* <div className="loan-application-view__score-body">
                      <span className="loan-application-view__score-body-title">EKYC</span>
                      <span className="loan-application-view__score-body-detail">Identical (%): {viewData.ekycIdenticalScore}</span>
                      <span className="loan-application-view__score-body-detail">KBA Correct Questions: {viewData.ekycKBAScore}</span>
                    </div> */}
                    <div className="loan-application-view__score-body">
                      <span className="loan-application-view__score-body-title">Score Description</span>
                      {viewData.ctosDescription &&
                        viewData.ctosDescription.map((e, i) => (
                          <span key={i} className="loan-application-view__score-body-detail">
                            {e}
                          </span>
                        ))}
                    </div>
                    {/* <a href={viewData.ctosScorecardUrl} target="_blank" rel="noreferrer" className="loan-application-view__score-ctos-report">
                      View CTOS Report
                    </a> */}
                  </>
                ) : renderUnauthorizedMsg() 
                }
                </div>
              )}

              {scoreTab.ivc === 2 && (
                <div className="loan-application-view__score-content-wrapper">
                {loanDetailsAccess.view_ivc_score_detail &&
                  viewData.internalScoreBreakdown &&
                  viewData.internalScoreBreakdown.length 
                  ?
                    viewData.internalScoreBreakdown.map((o, i) => {
                      return (
                        <div key={i} className="loan-application-view__score-content-row">
                          <div className="loan-application-view__score-content-column-1">{o.code}</div>
                          <div className="loan-application-view__score-content-column-2">
                            {/* {o.documentUrl ?
                              Object.entries(o.documentUrl).map(([key, value], index) => {
                                return(
                                  <div key={key+index} className="loan-application-view__download-wrapper" onClick={() => downloadIvcDocs(value, o.code, o.label)}>
                                    <BsDownload />
                                  </div>
                                )
                              }) : null
                            } */}
                            <span>{o.label}</span>
                          </div>
                          <div className="loan-application-view__score-content-column-3">{o.value} pts</div>
                        </div>
                      );
                    }) 
                  : (loanDetailsAccess.view_ivc_score_detail 
                    ? renderNoRecordMsg()
                    : renderUnauthorizedMsg()
                  )
                }
                </div>
              )}
            </div>

            <div className={getVideoWrapperClassNames(scoreTab)}>
              <div className="loan-application-view__video-tab-row">
                {loanDetailsAccess.interview && 
                <div className={getVideoTabClassNames(videoTab, "interview")} onClick={() => videoTabHandler("interview")}>
                  KYC Interview
                </div>
                }
                {loanDetailsAccess.live_briefing && 
                <div className={getVideoTabClassNames(videoTab, "briefing")} onClick={() => videoTabHandler("briefing")}>
                  Live Briefing
                </div>
                }
              </div>
              {(loanDetailsAccess.interview || loanDetailsAccess.live_briefing) &&
              <div className="loan-application-view__video-contents">
                {/* <div className={getLiveVideoClassNames(videoTab.interview)}>{true ? <AppOpenVidu sessionName={viewData.interviewSessionName} myUserName={viewData.agentUsername} buttonTitle="Meeting" history={history} /> : <span className="loan-application-view__video-none">No Meeting</span>}</div> */}
                <div className={getLiveVideoClassNames(videoTab.interview)}>
                  {viewData.interviewSessionName && viewData.status == "Initial Approved" ? (
                    // viewData.status != "Initial Approved" ? (
                    //   <button className="open-vidu__button-join-disable" disabled>
                    //     Join Meeting
                    //   </button>
                    // ) : (
                      <AppOpenVidu sessionName={viewData.interviewSessionName} myUserName={viewData.officerUsername} buttonTitle="Meeting" history={history} updateDisableSave={setDisableSaveBtn} />
                    // )
                  ) : (
                    viewData.interviewUrl !== null ? (
                      interviewVideo === true ? (
                        <div style={{width:"680px"}}>
                          <div><button style={{border:"none", backgroundColor:"transparent", float: "right", zIndex:"10", position:"relative"}}
                            onClick ={() => selectInterviewVideo(false)}><img src={iconClose} style={{width:"30px"}}/></button>
                          </div>
                          <Player style={{height:"300px"}}>
                           <source src={viewData.interviewUrl} />
                          </Player>
                        </div>
                      ) : (<img src={iconPlay} alt="play video icon" width={84} onClick ={() => selectInterviewVideo(true)} />)
                    ) : (<span className="loan-application-view__video-none">No Meeting</span>)
                  )}
                    
                </div>
                <div className={getLiveVideoClassNames(videoTab.briefing)}>
                  {viewData.liveBriefingSessionName && viewData.status == "Live Briefing" ? (
                    // viewData.status != "Live Briefing" ? (
                    //   <button className="open-vidu__button-join-disable" disabled>
                    //     Join Briefing
                    //   </button>
                    // ) : (
                      <AppOpenVidu sessionName={viewData.liveBriefingSessionName} myUserName={viewData.officerUsername} buttonTitle="Briefing" history={history} updateDisableSave={setDisableSaveBtn} />
                    // )
                  ) : (
                    viewData.liveBriefingUrl !== null ? (
                      liveBriefingVideo === true ? (
                        <div style={{width:"680px"}}>
                          <div><button style={{border:"none", backgroundColor:"transparent", float: "right", zIndex:"10", position:"relative"}}
                            onClick ={() => selectLiveBriefingVideo(false)}><img src={iconClose} style={{width:"30px"}}/></button>
                          </div>
                          <Player>
                            <source src={viewData.liveBriefingUrl} />
                          </Player>
                        </div>
                      ) : (<img src={iconPlay} alt="play video icon" width={84} onClick ={() => selectLiveBriefingVideo(true)} />)
                    ) : (<span className="loan-application-view__video-none">No Briefing</span>)
                  )}
                </div>
              </div>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PageLoanApplicationView;
